module.exports = __webpack_public_path__ + "img/ico_done.6ed95782.png";